import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Rocket, Users, ShieldCheck } from 'lucide-react';
import '../../App.css';

function StatsBar() {
  return (
    <section className="stats-section py-5">
      <Container>
        <Row className="text-center align-items-center">
          
          {/* Statistica 1 */}
          <Col md={4} className="mb-4 mb-md-0">
            <div className="icon-box mx-auto mb-3">
              <Rocket size={28} strokeWidth={2} color="#fbbc04" />
            </div>
            <h2 className="stat-number">3+</h2>
            <p className="stat-text">Proiecte Majore</p>
          </Col>

          {/* Statistica 2 (Cea nouă, mai interesantă) */}
          <Col md={4} className="mb-4 mb-md-0">
            <div className="icon-box mx-auto mb-3">
              <Users size={28} strokeWidth={2} color="#fbbc04" />
            </div>
            <h2 className="stat-number">2 Milioane</h2>
            {/* Aici poți schimba cu "Voluntari implicați" sau "Comunități locale" */}
            <p className="stat-text">Cetățeni sprijiniți</p> 
          </Col>

          {/* Statistica 3 */}
          <Col md={4}>
            <div className="icon-box mx-auto mb-3">
              <ShieldCheck size={28} strokeWidth={2} color="#fbbc04" />
            </div>
            <h2 className="stat-number">100%</h2>
            <p className="stat-text">Transparență</p>
          </Col>

        </Row>
      </Container>
    </section>
  );
}

export default StatsBar;